<template>
  <li class="query-list-item bool-card" :class="{isCloned: isCloned, overlay: isCloned || isDeleted, isTag: isTag && !isCloned}">
    <color-band :color="color" />

    <main :class="{'tag-padding': isTag}">
      <clone-overlay v-if="isCloned"
         :item="item"
         :resource-name="resourceName"
         @close="resetCloneToggle"
         @cloneResource="execCloneResource"
      />
      <delete-overlay v-else-if="isDeleted" :item="item" />

      <query-list-item-header v-else
        :item="item"
        :resource-name="resourceName"
        @toggleClone="cloneToggle"
        :color="color"
        :selectedTag="selectedTag"
        :showPrivateTags="showPrivateTags"
        @toggleSelectTag="$emit('toggleSelectTag')"
      />

      <collapse-transition v-if="!isTag">
        <div v-if="!showContent">
          <queryListItemFilters v-if="!hideFilters" :filters="item.filters || {}" />
          <queries-list :queries="item.queries || item.query" />
        </div>
      </collapse-transition>
    </main>
  </li>
</template>

<script>
// Mixins
import cloning from '../../../mixins/boolean-search/cloning'

// Components
import collapseTransition from "../../transitions/CollapseTransition.vue";
import colorBand from './queryListItemComponents/ColorBand.vue'
import cloneOverlay from './queryListItemComponents/CloneOverlay.vue'
import deleteOverlay from './queryListItemComponents/DeleteOverlay.vue'
import queryListItemHeader from './queryListItemComponents/QueryListItemHeader.vue'
import queryListItemFilters from './queryListItemComponents/QueryListItemFilters.vue'
import queriesList from './queryListItemComponents/QueriesList.vue'

//Config
import { searchTypes, tagCategoryType, multiSyntaxSearch } from '../../../config/bool-const'

//Plugins
import find from 'lodash/find'

export default {
  name: "QueryListItem",
  props: {
    item: {
      type: Object,
      isRequired: true
    },
    resourceName: {
      type: String,
      required: true
    },
    hideFilters: Boolean,
    isDeleted: Boolean,
    selectedTag: {
      type: Boolean,
      default: false
    },
    showPrivateTags: {
      type: Boolean,
      default: false
    },
  },

  mixins: [ cloning ],

  data() {
    return {
      clonedItem: null,
    }
  },
  computed: {
    showContent() { return this.isCloned || this.isDeleted },

    isTag() { return this.resourceName === 'tag_library' },

    color() {
      if(['group', 'group_library'].indexOf(this.resourceName) !== -1) {
        return '#9CA3AF';
      }
      else if(this.item.is_multi){
        return multiSyntaxSearch.color;
      }
      else if(['search', 'searches'].indexOf(this.resourceName) !== -1) {
        let searchTypeOptions = find(searchTypes, type => type.value === this.item.search_type);
        return searchTypeOptions && searchTypeOptions.color && searchTypeOptions.color.trim() !== '' ? searchTypeOptions.color : '#754cf5';
      } else {
        return tagCategoryType[this.item.category] ? tagCategoryType[this.item.category] : 'purple';
      }
    }
  },
  components: {
    collapseTransition,
    colorBand,
    cloneOverlay,
    deleteOverlay,
    queryListItemHeader,
    queryListItemFilters,
    queriesList
  }
}
</script>

<style scoped>
  .tag-padding {
    padding: 0.5rem 0.5rem 0.5rem 0.6rem!important;
  }
</style>